import util from '../util'

let controller = 'Handshake'

export default Object.assign({}, util.GetCrud(controller, ['get']), {
    GetAll: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller, dto)
    },
})
